import { render } from "./ExportToReportBtn.vue?vue&type=template&id=55303d99&ts=true"
import script from "./ExportToReportBtn.vue?vue&type=script&lang=ts"
export * from "./ExportToReportBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__